/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import Vue from 'vue';

import Tabulator from 'tabulator-tables';
window.Tabulator = Tabulator;

window.clipCopy = require('clipboard-copy');
window.moment = require('moment');

import {
    // BootstrapVue,
    // IconsPlugin
    ModalPlugin,
    ToastPlugin
} from 'bootstrap-vue'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// Vue.use(BootstrapVue);
// Vue.use(IconsPlugin);

Vue.use(ModalPlugin);
Vue.use(ToastPlugin);

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
require('./vueComponents');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

var Modal = require('./modal');
window.modal = new Modal();

const app = new Vue({
    el: '#app',
    data() {
        return {
            groupId: window.groupId || false,
            boardId: window.boardId || false,
            modal: window.modal,
        }
    },
    methods: {
        setGroup(id) {
            this.resetBoard();
            window.history.pushState({}, null, '/group/' + id);
            window.history.replaceState({}, null, '/group/' + id);
            this.groupId = id;
        },
        setBoard(id) {
            this.resetGroup();
            window.history.pushState({}, null, '/board/' + id);
            window.history.replaceState({}, null, '/board/' + id);
            this.boardId = id;
        },
        resetGroup() {
            this.groupId = false;
            window.history.pushState({}, null, '/');
            window.history.replaceState({}, null, '/');
        },
        resetBoard() {
            this.boardId = false;
            window.history.pushState({}, null, '/');
            window.history.replaceState({}, null, '/');
        },
        goneFullscreen() {
            let el = document.getElementById('title-nav');
            el.classList.add('d-none');
        },
        leftFullScreen() {
            let el = document.getElementById('title-nav');
            el.classList.remove('d-none');
        }
    },
});